import { render, staticRenderFns } from "./AlunoInformacoes.vue?vue&type=template&id=4e2d0e0a"
import script from "./AlunoInformacoes.vue?vue&type=script&lang=js"
export * from "./AlunoInformacoes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports